export default __webpack_public_path__ + "static/partner11-39bb0fdb5a3e5d032573fc0e6592c45f.jpg";